import styled from 'styled-components';
export const ButtonsSection = styled.div.withConfig({
  displayName: "HoverActionsstyle__ButtonsSection"
})(["top:-8px;right:-8px;position:absolute;z-index:1;"]);